import { onBeforeUnmount, onMounted, watch } from 'vue'
import { useNotificationStore } from '@/stores/notifications'

export function useNotificationSync() {
  const notifications = useNotificationStore()
  let timer: ReturnType<typeof setInterval> | undefined
  const refresh = () => {
    if (!document.hidden) void notifications.refreshUnreadCount()
  }
  watch(() => notifications.accountId, refresh, { immediate: true, flush: 'post' })
  onMounted(() => {
    timer = setInterval(refresh, 60_000)
    window.addEventListener('focus', refresh)
    document.addEventListener('visibilitychange', refresh)
  })
  onBeforeUnmount(() => {
    clearInterval(timer)
    window.removeEventListener('focus', refresh)
    document.removeEventListener('visibilitychange', refresh)
  })
  return notifications
}
